import { createSlice } from "@reduxjs/toolkit";

// Helper function to check if promotion is a normal type gift (excluding warranty extensions)
const isNormalGiftPromotion = (payload) => {
  return (
    payload.giftIdentityName !== "registrationextwarranty-10" &&
    payload.giftIdentityName !== "registrationextwarranty-12"
  );
};

// Helper function to check if a promotion is a warranty extension (cannot be removed)
const isWarrantyExtension = (giftIdentityName, promotionType) => {
  return (
    (giftIdentityName === "registrationextwarranty-10" &&
      promotionType === "Default") ||
    (giftIdentityName === "registrationextwarranty-12" &&
      promotionType === "Default")
  );
};

// Helper function to check if a promotion is a normal gift (excluding warranty extensions)
const isNormalGift = (promotion) => {
  return (
    promotion.promotionType === "Normal" &&
    promotion.giftIdentityName !== "registrationextwarranty-10" &&
    promotion.giftIdentityName !== "registrationextwarranty-12"
  );
};

const registrationSlice = createSlice({
  name: "registration",
  initialState: {
    registrationModel: {
      productInformation: [],
      promotions: [],
      contactDetails: [],
      consentTypes: [],
    },
    selectedGift: "",
    referenceNumber: "",
    registrationStatus: {},
  },
  reducers: {
    setProductInformation(state, action) {
      var currProdInf = [...state.registrationModel.productInformation];
      var field = state.registrationModel.productInformation.find(
        (x) => x.fieldName === action.payload.fieldName
      );
      if (!field) {
        currProdInf[action.payload.fieldName] = action.payload.value;
        state.registrationModel.productInformation.push({
          fieldName: action.payload.fieldName,
          value: action.payload.value,
          formFieldId: action.payload.formFieldId,
          fieldType: action.payload.fieldType,
        });
      } else {
        field["value"] = action.payload.value;
        state.registrationModel.productInformation = currProdInf;
      }
    },
    setPromotions(state, action) {
      state.selectedGift = action.payload.giftType;
      var field = state.registrationModel.promotions.find(
        (x) => x.promotionName === action.payload.promotionName
      );

      // Eğer promosyon zaten seçiliyse, kaldır (toggle)
      // Warranty extension promosyonları (registrationextwarranty-10 ve registrationextwarranty-12) kaldırılamaz
      if (
        field &&
        !isWarrantyExtension(
          action.payload.giftIdentityName,
          action.payload.promotionType
        )
      ) {
        state.registrationModel.promotions =
          state.registrationModel.promotions.filter(
            (x) => x.promotionName !== action.payload.promotionName
          );
        // Eğer kaldırılan "Normal" tipindeyse ve başka "Normal" kalmadıysa selectedGift'i temizle
        if (isNormalGiftPromotion(action.payload)) {
          var remainingNormalPromotions =
            state.registrationModel.promotions.filter(isNormalGift);
          if (remainingNormalPromotions.length === 0) {
            state.selectedGift = "";
          }
        }
        return;
      }

      // Yeni promosyon ekleme mantığı
      if (isNormalGiftPromotion(action.payload)) {
        var currPromotions = [...state.registrationModel.promotions];
        var normalPromotions = currPromotions.filter(isNormalGift);
        // Eğer zaten 2 "Normal" promosyon varsa ve yeni bir "Normal" ekleniyorsa, en eskisini kaldır
        if (normalPromotions.length >= 2) {
          // En eski "Normal" promosyonu bul ve kaldır
          var firstNormalPromotion = normalPromotions[0];
          state.registrationModel.promotions = currPromotions.filter(
            (x) => x !== firstNormalPromotion
          );
        }
      }

      state.registrationModel.promotions.push(action.payload);
    },
    setContactDetails(state, action) {
      var currConsentTypes = [];

      if (action.payload.fieldName.includes("consent-")) {
        currConsentTypes = [...state.registrationModel.consentTypes];
        var consentType = currConsentTypes.find(
          (x) => x.fieldName === action.payload.fieldName
        );
        if (!consentType) {
          state.registrationModel.consentTypes.push({
            fieldName: action.payload.fieldName,
            fieldValue: action.payload.value,
            formFieldId: action.payload.formFieldId,
            fieldType: action.payload.fieldType,
          });
        } else {
          consentType.fieldValue = action.payload.value;
          state.registrationModel.consentTypes = currConsentTypes;
        }
      } else {
        var currProdInf = [...state.registrationModel.contactDetails];
        var field = state.registrationModel.contactDetails.find(
          (x) => x.fieldName === action.payload.fieldName
        );
        if (!field) {
          currProdInf[action.payload.fieldName] = action.payload.value;
          state.registrationModel.contactDetails.push({
            fieldName: action.payload.fieldName,
            value: action.payload.value,
            formFieldId: action.payload.formFieldId,
            fieldType: action.payload.fieldType,
          });
        } else {
          field["value"] = action.payload.value;
          state.registrationModel.contactDetails = currProdInf;
        }
      }
    },
    setReferenceNumber(state, action) {
      state.referenceNumber = action.payload.referenceNumber;
    },
    setRegistrationStatus(state, action) {
      state.registrationStatus = action.payload;
    },
    clearModel(state) {
      state.registrationModel = {
        productInformation: [],
        promotions: [],
        contactDetails: [],
        consentTypes: [],
      };
      state.referenceNumber = "";
      state.selectedGift = "";
      state.registrationStatus = {};
    },
  },
});

export const registrationActions = registrationSlice.actions;
export default registrationSlice;
